import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Table, Pagination, Modal } from 'antd';
import { apiUrls } from '../apiUrls.js';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import InputNumberFormat from "../components/InputNumberFormat.js";
import DatePicker, { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import HideSidebarInMobileMode from "../components/HideSidebarInMobileMode.js";
const { Option } = Select;
const baseURL = apiUrls.baseURL;

const initialBillModel = {
    amount: '',
    userId: '',
    billType: '',
    description: '',
    payDateDeadLine: ''
};

const AddMemberProgram = React.memo(({ data, onRefresh }) => {

    const navigate = useNavigate();
    const [isShowModalVisible, setIsShowModalVisible] = useState(false);
    const [dropDownUser, setDropDownUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [model, setModel] = useState({});
    const [isShowCreateBillModalVisible, setIsShowCreateBillModalVisible] = useState(false);
    const [payDeadLineDate, setPayDeadLineDate] = useState(null);
    const [billModel, setBillModel] = useState(initialBillModel);
    const [loadingSave, setLoadingSave] = useState(false);
    const permissions = useSelector((state) => state.permissions.permissions);

    useEffect(() => {
        setModel({ ...model, programId: data.id })
        fetchUsers()
    }, [])

    const fetchUsers = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            var result = response.data.data;
            setDropDownUsers(result);
        } catch (error) {
        } finally {
        }
    };

    const submit = async () => {

        setLoading(true)

        if (model.amount == undefined || model.amount == null) {
            setLoading(false)
            return toast.error("مبلغ وارد شده صحیح نیست", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        const token = localStorage.getItem('damavandclub-token')
        try {
            await axios.post(`${baseURL}/userprogram/addmember`, model, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            onRefresh()
            setIsShowModalVisible(false)
            setLoading(false)
            return toast.success("با موفقیت ثبت شد", {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } catch (error) {
            setIsShowModalVisible(false)
            setLoading(false)
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setIsShowModalVisible(false)
            setLoading(false)
        }
    };

    const createBill = async () => {

        if (model.userId == undefined || model.userId == null) {
            return toast.warning("هیچ عضوی انتخاب نشده است", {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
        }

        if (billModel.amount == undefined || billModel.amount == null || billModel.amount == 0 || billModel.amount == '') {
            return toast.warning("مبلغ وارد شده صحیح نیست", {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
        }

        setLoadingSave(true);

        const token = localStorage.getItem('damavandclub-token')

        try {
            await axios.post(`${baseURL}/bill/createforeducation`, billModel, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            setLoadingSave(false);
            setBillModel({ ...billModel, userId: null })
            toast.success("ذخیره شد", {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setIsShowCreateBillModalVisible(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 6000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                //className: 'custom-toast',
                pauseOnHover: true,
                draggable: true,
            });
            setLoadingSave(false);
        } finally {
            setLoadingSave(false);
        }
    };

    const showCreateBillModal = async () => {
        //setBillModel({})
        setIsShowCreateBillModalVisible(true)
    };

    const setSelectedPayDeadLineDate = async (date) => {
        setPayDeadLineDate({
            year: date.year,
            month: date.month,
            day: date.day
        });
        setBillModel({ ...billModel, payDateDeadLine: `${date.year}/${date.month}/${date.day}` })
    }

    return (
        <>
            <Button onClick={() => { setIsShowModalVisible(true); setModel({ ...model, userId: null, amount: null }) }}
                style={{ marginTop: 10, width: '100%' }}>اضافه کردن عضو به برنامه</Button>

            <Modal
                title={`اضافه کردن عضو به برنامه :  ${data.nameFa}`}
                open={isShowModalVisible}
                closable={false}
                okButtonProps={null}
                bodyStyle={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}
                footer={<div className='row-container'>
                    <Button onClick={() => setIsShowModalVisible(false)} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary" loading={loading}
                        onClick={() => submit()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>تایید</Button>
                </div>}
                onCancel={() => setIsShowModalVisible(false)}
            >
                <span style={{ color: 'red' }}>سرپرست یا مدیر کارگروه گرامی</span>
                این پنجره برای اضافه کردن دوست شما با مبلغی کمتر از هزینه برنامه طراحی شده است. شما میتوانید عضو مورد نظر را از لیست زیر جستجو و سپس مبلغ مورد نظر را در کادر زیر آن وارد نمایید. بدیهی است هر گونه مسئولیت این کار پس از اتمام برنامه و در هنگام محاسبات دستمزد شما، بر عهده خودتان خواهد بود. پس از اتمام برنامه دستمزد شما بر اساس واریزی های اعضای برنامه محاسبه خواهد شد!
                <Select
                    style={{ width: '100%', marginTop: 10 }}
                    placeholder="انتخاب عضو"
                    allowClear={true}
                    showSearch
                    optionFilterProp="label"
                    onChange={(value) => {
                        setModel({ ...model, userId: value });
                        setBillModel({ ...billModel, userId: value })
                    }}
                    value={model.userId}
                >
                    {dropDownUser?.map((item) => (
                        <Option key={item.id} label={item.displayName} value={item.id}>
                            {item.displayName}
                        </Option>
                    ))}
                </Select>

                <label className='margintop-18'>هزینه برنامه(ریال) با اعداد انگلیسی وارد کنید</label>
                <InputNumberFormat value={model.amount} onValueChange={(value) => setModel({ ...model, amount: value })} />

                <HideSidebarInMobileMode />
                {permissions.includes('educationclassessreport') ? <Button onClick={() => showCreateBillModal()}
                    style={{ backgroundColor: 'rgb(37 204 99)', marginTop: 20, width: '100%'}}
                    type="primary"><label>ایجاد اعتبار به عنوان کمک هزینه برای این عضو</label></Button> : null}

            </Modal >

            <Modal
                title={`ایجاد قبض`}
                open={isShowCreateBillModalVisible}
                width={500}
                closable={false}
                okButtonProps={null}
                footer={<div className='row-container'>
                    <Button onClick={() => {
                        setBillModel(initialBillModel)
                        setPayDeadLineDate(null);
                        setIsShowCreateBillModalVisible(false)
                    }} style={{ width: '100%' }}>بستن</Button>
                    <Button type="primary" loading={loadingSave}
                        onClick={() => createBill()}
                        style={{ width: '100%', marginRight: 10, backgroundColor: 'rgb(10, 23, 43)' }}>ذخیره</Button>
                </div>}
            >
                <InputNumberFormat value={billModel.amount} placeholder="مبلغ(ریال)-با اعداد انگلیسی"
                    onValueChange={(value) => setBillModel({ ...billModel, amount: value })} />

                <input
                    placeholder='توضیحات'
                    value={billModel.description}
                    onChange={(event) => setBillModel({ ...billModel, description: event.target.value })}
                    style={{ marginTop: 10, height: 30, width: '100%' }} />
                <label className='margintop-7'>مهلت پرداخت</label>
                <div className='margintop-7 center-content customDatePickerWidth'>
                    <DatePicker
                        value={payDeadLineDate || null}
                        onChange={(value) => setSelectedPayDeadLineDate(value)}
                        shouldHighlightWeekends
                        locale='fa'
                    />
                </div>
            </Modal>
        </>
    );
});

AddMemberProgram.propTypes = {
    data: PropTypes.any,
    onRefresh: PropTypes.any
};

AddMemberProgram.displayName = 'AddMemberProgram';

export default AddMemberProgram;
